"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            latestCourses: [],
            latestPrograms: []
        };
        this.fetchLatestCourses();
        this.fetchLatestPrograms();
    },
    fetchLatestCourses: async function () {
        try {
            const {error, message, results} = await Request('/learner/course/latest/list?limit=3');
            if (error)
                console.log('Error Fetching Latest Courses: ', message);
            this.state.latestCourses = results || [];
        } catch (error) {
            console.log('Error Fetching Latest Courses');
        }
    },
    fetchLatestPrograms: async function () {
        try {
            const {error, message, results} = await Request('/learner/program/latest/list?limit=3');
            if (error)
                console.log('Error Fetching Latest Programs: ', message);
            this.state.latestPrograms = results || [];
        } catch (error) {
            console.log('Error Fetching Latest Programs');
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Explore/components/Latest.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Row_template = require("../../../../components/Row/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Row_tag = marko_loadTag(Row_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Card_template = require("../../../components/Card.marko"),
    Card_tag = marko_loadTag(Card_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_attrs0 = {
        "class": "px-1",
        id: "latest"
      },
    marko_attrs1 = {
        "class": "mb-0 text-ellipsis-2"
      },
    marko_attrs2 = {
        style: "margin-top:6.5rem;margin-left:0",
        "class": "d-inline-block position-absolute zindex-4 left-0"
      },
    marko_attrs3 = {
        style: "margin-top:6.5rem;margin-right:0",
        "class": "d-inline-block position-absolute zindex-4 right-0"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("d74f85"),
    marko_node0 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "21", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  function macro_ExploreCard(out, { href, name, description, poster }) {
    WSAdapt_tag({
        qs: "col-md-6 col-12",
        hs: "col-md-6 col-12",
        ns: "col-md-4 col-12",
        renderBody: function(out) {
          Card_tag({
              class: "round",
              style: "min-height:15rem",
              body: {
                  renderBody: function(out) {
                    Row_tag({
                        col: [
                            {
                                class: "col",
                                renderBody: function(out) {
                                  out.e("h5", null, "5", component, 1)
                                    .t(name, component);

                                  out.e("p", marko_attrs1, "6", component, 1)
                                    .t(description, component);
                                }
                              },
                            {
                                ns: "col-4",
                                hs: "col-6",
                                qs: "col-4",
                                renderBody: function(out) {
                                  out.e("div", {
                                      "class": "rounded-circle",
                                      style: marko_styleValue(("width:10rem;height:10rem;background:url('" + poster) + "') center;background-size:cover")
                                    }, "8", component, 0, 1);
                                }
                              }
                          ]
                      }, out, __component, "3");
                  }
                },
              footer: {
                  class: "py-0",
                  renderBody: function(out) {
                    route_link_tag({
                        href: href,
                        renderBody: function(out) {
                          Locale_tag({
                              text: "View Details"
                            }, out, __component, "11");
                        }
                      }, out, __component, "10");
                  }
                }
            }, out, __component, "1");
        }
      }, out, __component, "0");
  }

  out.be("section", marko_attrs0, "12", component);

  if (state.latestCourses.length || state.latestPrograms.length) {
    out.be("h6", null, "13", component);

    Locale_tag({
        text: "All Latest"
      }, out, __component, "14");

    out.ee();

    out.be("span", marko_attrs2, "15", component);

    Bx_tag({
        type: "chevron-left",
        class: "font-large-4 theme-color-lighten"
      }, out, __component, "16");

    out.ee();

    out.be("span", marko_attrs3, "17", component);

    Bx_tag({
        type: "chevron-right",
        class: "font-large-4 text-muted"
      }, out, __component, "18");

    out.ee();

    Row_tag({
        renderBody: function(out) {
          var $for$0 = 0;

          marko_forOf(state.latestCourses, function(course) {
            var $keyScope$0 = "[" + (($for$0++) + "]");

            marko_dynamicTag(out, macro_ExploreCard, function() {
              return marko_assign({
                  href: "/course/" + course.courseId
                }, course);
            }, null, null, null, __component, "22" + $keyScope$0);
          });

          var $for$1 = 0;

          marko_forOf(state.latestPrograms, function(program) {
            var $keyScope$1 = "[" + (($for$1++) + "]");

            marko_dynamicTag(out, macro_ExploreCard, function() {
              return marko_assign({
                  href: "/program/" + program.programId
                }, program);
            }, null, null, null, __component, "23" + $keyScope$1);
          });
        }
      }, out, __component, "19");

    out.n(marko_node0, component);

    out.n(marko_node1, component);
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
